'use client';

// react-cookie-consent is a client-only class component, so this banner must sit
// inside a client boundary. Marking it here lets server components (see SiteChrome)
// render it directly instead of each caller adding its own wrapper.
import CookieConsent, { Cookies } from 'react-cookie-consent';
import './style.css';
import { Link } from '@/components/link/Link';

export default function CookiesConsent() {
  const handleAcceptAll = () => {
    Cookies.set('cookieConsent', 'accepted');
  };

  const handleRejectAll = () => {
    Cookies.remove('cookieConsent');
  };

  return (
    <>
      <div
        className={
          'fixed bottom-0 left-0 z-50 w-full border-t border-neutral-100 bg-white shadow-2xl'
        }
      >
        <CookieConsent
          location="bottom"
          buttonWrapperClasses="rrc-button-wrap"
          containerClasses="rrc-container"
          disableStyles={true}
          cookieName="myAwesomeCookieConsent"
          onAccept={handleAcceptAll}
          onDecline={handleRejectAll}
          enableDeclineButton
          declineButtonText="Alle ablehnen"
          buttonText="Alle annehmen"
        >
          <div className="flex max-w-4xl flex-row">
            <p className="text-sm leading-6 text-gray-900">
              Wir verwenden eigene Cookies sowie Cookies von Drittanbietern, um
              Ihr Nutzungserlebnis zu verbessern, unseren Datenverkehr zu
              analysieren und für Sicherheits- sowie Marketingzwecke. Weitere
              Informationen finden Sie in unserer
              <Link
                href="https://cms.smzh.ch/uploads/smzh_Datenschutz_1_31c1865b61_bd9dda3646.pdf"
                variant="tertiary"
                className="ml-1 !inline-block !w-fit font-bold underline underline-offset-4"
              >
                Datenschutzerklärung.
              </Link>
            </p>
          </div>
        </CookieConsent>
      </div>
    </>
  );
}
